import { clsx } from 'clsx';
import { LazyImage } from '@crehana/compass.ui';
import { CrehanaPlayerWrapper } from '@crehana/player';
import { LANGUAGES } from '@crehana/ts-types';
import { DEFAULT_IMG_CONTENT } from "../constants";
import { jsx as _jsx } from "react/jsx-runtime";
var COMMON_COVER_CLASSNAME = 'tw-w-full tw-h-14.4';
var CourseCover = function CourseCover(_ref) {
  var courseId = _ref.courseId,
    title = _ref.title,
    _ref$hovered = _ref.hovered,
    hovered = _ref$hovered === void 0 ? false : _ref$hovered,
    isCrehanaCourse = _ref.isCrehanaCourse,
    coverImage = _ref.coverImage,
    _ref$trailerSources = _ref.trailerSources,
    trailerSources = _ref$trailerSources === void 0 ? [] : _ref$trailerSources,
    onTimeUpdate = _ref.onTimeUpdate,
    sizeImage = _ref.sizeImage;
  var shouldRenderTrailer = hovered && !!isCrehanaCourse && trailerSources.length > 0;
  return shouldRenderTrailer ? /*#__PURE__*/_jsx(CrehanaPlayerWrapper, {
    videoId: 'video-' + courseId,
    autoplay: true,
    hideLogo: true,
    hiddenNotes: true,
    hideSkipButtons: true,
    hideSpeedOptions: true,
    sources: trailerSources,
    defaultAudioLang: LANGUAGES.ES,
    defaultSubtitleLang: LANGUAGES.ES,
    orientation: "portrait",
    defaultMuted: true,
    className: COMMON_COVER_CLASSNAME,
    onTimeUpdate: onTimeUpdate
  }) : /*#__PURE__*/_jsx(LazyImage, {
    alt: title,
    src: coverImage,
    placeholder: DEFAULT_IMG_CONTENT,
    className: clsx(COMMON_COVER_CLASSNAME, sizeImage),
    imgClassName: "tw-object-cover tw-w-full tw-h-full",
    imgxParams: {
      fit: 'crop',
      crop: 'faces',
      w: 260,
      h: 144,
      q: 100
    }
  });
};
export default CourseCover;